
/**
 * １つのファイルデータ状態のクラス
 * タグ属性から初期状態を設定することも可能（一部は不可）
 * ex. <kz-file files='[{"state":"saved","src":"/uploads/xxx.jpg"},{}...]' endpoint="/kz-file/ep.php">
*/
import { sizeLabel } from "./kz-functions";
export class Afile {

	// プロパティ
	state                    : string; // uploading=アップロード中, temped=一時保存完了, saved=保存済みファイルロード, error=一時保存失敗
	src                      : string; // ブラウザ側からリンクする際のURL。新規アップロード時やアップ失敗時はカラ。
	filename                 : string; // 新規アップロード時にセットされるオリジナルファイル名。show_filename()メソッドはこれを返すが、空白の場合はsrcからファイル名を抜き出す。
	size                     : number;
	before_size              : number;
	is_hover                 : boolean;
	is_modal                 : boolean;
	checked_delete           : boolean;
	message                  : string;
	image_loaded             : boolean;
	anim_simple_loading_hide : boolean;
	anim_afile_cancel        : boolean;
	temped_name              : string;
	saved_name               : string;
	inputfile                : File;
	width                    : number;
	height                   : number;
	aspect                   : number;

	// コンストラクタ
	constructor(setdata: any) {
		this.state          = setdata.state
		this.src            = setdata.src
		this.filename       = setdata.filename
		this.size           = setdata.size
		this.before_size    = setdata.before_size
		this.checked_delete = setdata.checked_delete
		this.message        = setdata.message
		this.temped_name    = setdata.temped_name
		this.saved_name     = setdata.saved_name
		this.inputfile      = setdata.inputfile
		this.width          = setdata.width
		this.height         = setdata.height
		this.aspect         = setdata.aspect
	}

	// メソッド：表示用名前
	show_filename(): string|null
	{
		if(this.filename) return this.filename;
		if(!this.src) return '';
		let matches: RegExpMatchArray
		if(matches = this.src.match(/([^\/\\]+)$/)) return matches[1]
	}

	// メソッド：表示用サイズ
	show_size(): string|null
	{
		if(this.before_size) {
			return sizeLabel(this.before_size)+'→'+sizeLabel(this.size);
		} else {
			return sizeLabel(this.size);
		}

	}

	// メソッド：ファイル名から画像ファイルかどうかを返す
	is_image(): boolean
	{
		const filename = this.show_filename();
		return !!filename.match(/\.(jpe?g|png|gif|webp)$/i);
	}

	// メソッド：ファイル名から動画ファイルかどうかを返す
	is_video(): boolean
	{
		const filename = this.show_filename();
		return !!filename.match(/\.(mp4|webm|og[mvg])$/i);
	}

	// メソッド：ファイル名から音声ファイルかどうかを返す
	is_audio(): boolean
	{
		const filename = this.show_filename();
		return !!filename.match(/\.(mp3|wav)$/i);
	}

	// メソッド：ファイル名からメディアファイルかどうかを返す
	is_media(): boolean
	{
		return this.is_image() || this.is_video() || this.is_audio()
	}

	// メソッド：ファイル名からアーカイブファイルかどうかを返す
	is_archive(): boolean
	{
		const filename = this.show_filename();
		return !!filename.match(/\.(zip|lzh|7z|tar|gz)$/i);
	}

	// メソッド：ファイル名に則したアイコンタイプを返す
	get_icon_type(): string|null
	{
		const filename = this.show_filename()
		if(filename.match(/docx?$/i)) return 'word';
		else if(filename.match(/xlsx?$/i)) return 'excel';
		else if(filename.match(/pptx?$/i)) return 'powerpoint';
		else if(filename.match(/pdf$/i)) return 'pdf';
		else if(this.is_archive()) return 'archive';
		else if(this.is_image()) return 'image';
		else if(this.is_video()) return 'video';
		else if(this.is_audio()) return 'audio';
		return 'other';
	}

	// メソッド：ファイル名に則したアイコンタグ <svg> を返す
	show_icon(): string|null
	{
		return '<svg><use xlink:href="#'+this.get_icon_type()+'"/></svg>';
	}
}
